import { Component,  OnChanges, SimpleChanges, OnInit, Input, AfterViewInit, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { InventoryService } from '../../services/inventory.service';
import { PurchasingService } from '../../services/purchasing.service';
import { OrdersService } from '../../services/orders.service';
import { OmsService } from '../../services/oms.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { FormBuilder, FormGroup, Validators, UntypedFormControl, UntypedFormGroup, FormControl } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {Buffer} from 'buffer';
import { debounceTime, distinctUntilChanged, startWith, tap, delay } from 'rxjs/operators';


@Component({
  selector: 'app-warehouse-finalizerec',
  templateUrl: './warehouse-finalizerec.component.html',
  styleUrls: ['./warehouse-finalizerec.component.scss'],
  animations: [
	  trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 180deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			state('orderlookup', style({
				transform: 'rotateY(179deg)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
			transition('inactive => orderlookup', animate('500ms ease-out')),
			transition('orderlookup => inactive', animate('500ms ease-in')),
		]),
  ]
})
export class WarehouseFinalizerecComponent implements OnInit {
	@Input() vendor_selected: any = false;
	today = new Date();
	color: any = 'blue';

	location: any = '';
	locations: any = [];
	suppliers: any = false;
	user: any = [];

	CHAT_ROOM = "OrderBoard";
	sheetForm: FormGroup;
	sending: boolean = false;
	submiting: boolean = false;
	counting_items: any =false;
	fetching: boolean = false;
	flip: string = 'inactive';

	recitems: any = false;
	token: any = false;
	loadingdatasubscription: any = false;
	total_scanned: number = 0;
	discrepancy: string = 'inactive';
	showValidTable: boolean = false;
	validScans: any = [];
	invalidScans: any = [];

	vendor_formgroup: FormControl<any>[] = [];
	vendor_fg: FormGroup;


	unique_vendors: any = false;
	looprequest: boolean;
	discrepancy_vendors: any = false;
	selected_vendors: any = [];
	filtered_recitems: any;


	constructor(private fb: FormBuilder,private route: ActivatedRoute, public router: Router, private modalService: NgbModal, private omsService: OmsService, private globalSearchService: GlobalSearchService, private inventoryService: InventoryService, public ordersService: OrdersService, public purchasingService: PurchasingService) {

		this.globalSearchService.mesagesallowed.next(false);
		this.globalSearchService.user.subscribe((result) => {
			this.user = result;
		});

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.user.subscribe((u: any) => {
			this.user = u;
			this.location = u.user.defaultlocation.loccode
		});

	}

	ngOnInit(): void {

		// First load locations, then initialize form
		this.globalSearchService.locations.subscribe(async (results: any) => {
			this.locations = results;
			this.initializeForm();
		});

		this.omsService.subscribeToRecScanUpdate((err, data) => {
			//reload data on incoming message - currently double sending
			
			this.loadData()
			this.filterScans();
		});

	}

	private initializeForm(): void {
		// Ensure locations array is populated before accessing locations[0]
		if (!this.locations || this.locations.length === 0) {
			console.warn('Locations array is empty or undefined, cannot initialize form');
			return;
		}

		this.purchasingService.getSuppliers('').subscribe(async (results: any) => {
			this.suppliers = results;
			this.sheetForm = this.fb.group({
				keywords: [''],
				location: [this.locations[0].loccode, Validators.required],
				vendor: [this.vendor_selected, Validators.required],
				category: [''],
				lineid: [''],
				stockid: [''],
			});
			this.loadData();
		});
	}


	uniqueVendors(datain: any) {
		this.unique_vendors = []
		datain.forEach((vendor: any, index) => {
			this.unique_vendors[index] = vendor.vendor;
		});
	}

	vendorTotals(vendor: any) {

		let vendor_total= this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 0){
				addon = parseFloat(items.qty);
			};
			return accumulator + addon;
		}, 0);

		return vendor_total;
	}

	loadData() {

		if(this.loadingdatasubscription) {
			//prevent double calls cancel the firstone
			this.loadingdatasubscription.unsubscribe();
		}

		this.loadingdatasubscription = this.purchasingService.getRecs(this.sheetForm.value).subscribe( r => {
			this.recitems = r;
		});
	}

	resetSheets(event: any) {
		if(event) {
			this.counting_items = false;
			this.fetching = false;
			this.flip = 'inactive';
		}
	}

	pdf() {

	}

	keywordItemSearch() {

	}

	keywordSearch() {

	}

	selectVendor(supplier: any) {
		this.vendor_selected = supplier.supplierid
		this.sheetForm.get('vendor').setValue(supplier.supplierid)
	}

	selectCategory(value: any) {
		this.sheetForm.get('category').setValue(value.categoryid)
	}

	selectProductLine(value: any) {
		this.sheetForm.get('lineid').setValue(value.line_field)
	}


	setQty(event: any, item: any) {
		item.counted = parseFloat(event.target.value);
	}

	saveCounts() {

	}

	finalizeRec() {
		let data = {}
		this.submiting = true;
		let input = this.filtered_recitems.length > 0 ? this.filtered_recitems : this.recitems;
		this.purchasingService.finalizeRec(input).subscribe(async (results: any) => {
			this.submiting = false;
			this.loadData();
			this.omsService.sendRecScanUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
			this.discrepancyFlip();
		})
	}

	removeItem(item: any) {
		let index = this.recitems.indexOf(item);
		// Send proper data for OMS update to notify other devices
		const data = {
			message: {
				item: {
					stockid: item.stockid,
					vendor: item.vendor,
					loccode: item.loccode,
					action: 'removed'
				}
			},
			sourceToken: this.token || 'finalize-rec'
		};
		this.purchasingService.removeRec(this.recitems[index]).subscribe(async (results: any) => {
			this.recitems.splice(index,1)
			this.omsService.sendRecScanUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
			this.filterScans();
		})
	}


	updateBin(value: any, item: any) {
		let index = this.recitems.indexOf(item);
		this.recitems[index].bin= value;
	}

	totalScannedRec() {
		this.total_scanned = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 0){
				addon = parseFloat(items.qty);
			};
			return accumulator + addon;
		}, 0);

		return this.total_scanned;
	}

	totalScannedSend() {
		this.total_scanned = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 1){
				addon = parseFloat(items.qty);
			};
			return accumulator + addon;
		}, 0);
		return this.total_scanned;
	}

	totalReqPo() {
		let poreq = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 0){
				if(parseFloat(items.qty) > parseFloat(items.qop)) {
					addon = parseFloat(items.qty) - parseFloat(items.qop);
				}
			}
			return accumulator + addon;
		}, 0);

		return poreq;
	}

	totalReqRga() {
		let rga_req = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 1){
				if(parseFloat(items.qty) > parseFloat(items.qor)) {
					addon = parseFloat(items.qty) - parseFloat(items.qor);
				}
			}
			return accumulator + addon;
		}, 0);
		return rga_req;
	}

	totalForPo() {
		let poreq = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 0){
				if(parseFloat(items.qty) <= parseFloat(items.qop)) {
					addon = parseFloat(items.qty);
				}
			}
			return accumulator + addon;
		}, 0);
		return poreq;
	}

	totalForRga() {
		let poreq = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.in_out == 1){
				if(parseFloat(items.qty) <= parseFloat(items.qor)) {
					addon = parseFloat(items.qty);
				}
			}
			return accumulator + addon;
		}, 0);
		return poreq;
	}

	totalCommited() {
		let commited = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(parseFloat(items.qos)) {
				addon = parseFloat(items.qos);
			}
			return accumulator + addon;
		}, 0);
		return commited;
	}

	getFirstScanTime(): string {
		if (!this.recitems || this.recitems.length === 0) return '-';
		const dates = this.recitems
			.filter(item => item.date_rec)
			.map(item => new Date(item.date_rec).getTime())
			.filter(time => !isNaN(time));
		if (dates.length === 0) return '-';
		const firstTime = new Date(Math.min(...dates));
		return firstTime.toISOString();
	}

	getLastScanTime(): string {
		if (!this.recitems || this.recitems.length === 0) return '-';
		const dates = this.recitems
			.filter(item => item.date_rec)
			.map(item => new Date(item.date_rec).getTime())
			.filter(time => !isNaN(time));
		if (dates.length === 0) return '-';
		const lastTime = new Date(Math.max(...dates));
		return lastTime.toISOString();
	}

	getDurationSeconds(): number {
		if (!this.recitems || this.recitems.length === 0) return 0;
		const dates = this.recitems
			.filter(item => item.date_rec)
			.map(item => new Date(item.date_rec).getTime())
			.filter(time => !isNaN(time));
		if (dates.length === 0) return 0;
		const first = Math.min(...dates);
		const last = Math.max(...dates);
		return Math.floor((last - first) / 1000);
	}

	getOverScanPercentage(): number {
		if (!this.recitems || this.recitems.length === 0) return 0;
		let overScanned = 0;
		this.recitems.forEach(item => {
			if (item.in_out == 0 && parseFloat(item.qty) > parseFloat(item.qop)) {
				overScanned++;
			}
			if (item.in_out == 1 && parseFloat(item.qty) > parseFloat(item.qor || 0)) {
				overScanned++;
			}
		});
		return Math.round((overScanned / this.recitems.length) * 100);
	}

	getGoodPercentage(): number {
		const totalScans = this.validScans.length + this.invalidScans.length;
		if (totalScans === 0) return 0;
		return Math.round((this.validScans.length / totalScans) * 100);
	}

	updateRec(value: any, item: any) {
		let index = this.recitems.indexOf(item);

		if(value < 0 ){
			value = 0;
		}
		item.qty = value;

		let data = {};
		this.purchasingService.updateScanned(item).subscribe((updated_item: any)  =>{
			this.omsService.sendRecScanUpdate({ data, roomName: this.CHAT_ROOM }, cb => {});
			this.globalSearchService.showNotification('Saved','success','top','right');
		});

	}

	saveRec(item:any) {
		let index = this.recitems.indexOf(item);
		this.purchasingService.updateRec(this.recitems[index]).subscribe(async (results: any) => {
			this.recitems = results
			this.globalSearchService.showNotification('Saved','success','top','center');
		})
	}

	identify(index, item) {
		return item.line;
	}

	sanitizeNumber(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(0));
	}

	toggleFlip() {
		this.flip = (this.flip =='inactive') ? 'active' : 'inactive';
		if(this.flip == 'active') {

		}
	}

	ngOnChanges(changes: any) {
	}

	discrepancyFlip(){
		this.discrepancy = (this.discrepancy =='inactive') ? 'active' : 'inactive';
		if(this.discrepancy == 'active'){
			this.selected_vendors = [];
			this.discrepancy_vendors = [];
			this.filtered_recitems = [];
			this.filterScans()
			this.genFormcontrols();
		}
	}

	itemTotalReceived(item:any) {
		let total = this.recitems.reduce(function(accumulator: number, items: any) {
			var addon = 0;
			if(items.stockid == item.stockid){
				addon += parseFloat(items.qty);
			}
			return accumulator + addon;
		}, 0);

		return total;
	}

	filterScans(vendor_recs?){
		if(vendor_recs == '' || vendor_recs == undefined){
			this.recitems.forEach(item => {
				(item.qty == item.qop || item.qty == item.qor || item.total_need_filled == this.itemTotalReceived(item)) && item.total_rec <= item.total_need_filled ?
					(this.validScans.includes(item) ? '' : this.validScans.push(item)) :
					(this.invalidScans.includes(item) ? '' : this.invalidScans.push(item));
			});

			if(this.recitems.length != (this.validScans.length + this.invalidScans.length)){
				this.validScans = [];
				this.invalidScans = [];
				this.filterScans();
			}

		} else {
			this.validScans = [];
			this.invalidScans = [];
			vendor_recs.forEach(item => {
				//partial scans showing as invalid on split
				(item.qty == item.qop || item.qty == item.qor || item.total_need_filled == this.itemTotalReceived(item)) && item.total_rec <= item.total_need_filled ?
					(this.validScans.includes(item) ? '' : this.validScans.push(item)) :
					(this.invalidScans.includes(item) ? '' : this.invalidScans.push(item));
			});
			if(vendor_recs.length != (this.validScans.length + this.invalidScans.length)){
				this.validScans = [];
				this.invalidScans = [];
				this.filterScans(vendor_recs);
			}
		}
	}


	genFormcontrols(){
		this.discrepancy_vendors = [];
		(this.recitems).forEach(element => {
			this.discrepancy_vendors.includes(element.vendor) ? '' : this.discrepancy_vendors.push(element.vendor);
		});

		if(this.discrepancy_vendors.length > 1){
			this.selected_vendors = [];

			this.vendor_fg = this.fb.group({});

			(this.discrepancy_vendors).forEach(vendor => {
				this.vendor_fg.addControl(vendor, new UntypedFormControl(true))
				this.selected_vendors.push(vendor);

				this.vendor_fg.get(vendor).valueChanges.subscribe((newV)=>{
					newV == false ? this.selected_vendors.splice(this.selected_vendors.indexOf(vendor), 1) : this.selected_vendors.push(vendor);
					this.filterScansByVendor(this.selected_vendors);
				})
			});
		} else{
			this.selected_vendors = [];
			this.filtered_recitems = [];
		}
	}

	filterScansByVendor(vendors){
		this.filtered_recitems = this.recitems;
		this.filtered_recitems = this.filtered_recitems.filter((scan) => vendors.includes(scan.vendor));
		this.filterScans(this.filtered_recitems);
	}

	toggleValidTable(){
		this.showValidTable = this.showValidTable == true ? false : true;
	}

	mailDiscrepancy(){
		// return;
		// this.filterScans();

		let index = 1;
		let table = '';
		let tableHead =
						'<table style="border-collapse: collapse; width: 100%; margin: 20px 0; font-family: Arial, sans-serif; font-size: 12px;">' +
							'<thead>' +
								'<tr>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">INDEX</th>'+
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">ITEM</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">VENDOR</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">BIN</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">QTY_RECEIVED</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">MIN</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">MAX</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">QOH</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">QOO</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">REMAINING</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">QOR</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">COMMITED</th>' +
									'<th style="text-align: center; background-color: #2c3e50; color: white; padding: 10px; border: 1px solid #34495e;">SCAN_STATUS</th>' +
								'</tr>' +
							'</thead>';



		let bodies = [this.validScans, this.invalidScans];
		let tableBody = "";
		let validScansBody = "";
		let invalidScansBody = "";
		let bodyIndex = 0;
		let red = "#df232378";
		let pink = "#ff59ba78";
		let yellow = "#c7ff0078";
		let blue = "#444ee478";
		let orange = "#fc7e0998";
		let green = "#38ff0078";
		let purple = "#750dbbae";
		let legend = {
			rec:[],
			send:[],
			shared:[],
		};

		bodies.forEach(scans => {
			// tableBody = "<tbody>";
			if(scans.length > 0){
				scans.forEach(item => {

					let status = {isSet: false, value: ''};
					if(item.in_out == 0){
						if(item.qty != item.qop){
							if(item.total_rec == item.total_need_filled) {
								status.value = "OK";
								status.isSet = true;
							}
							if (item.qop == 0 || item.qop == null){
								status.value = "NO PO";
								status.isSet = true;
							}

							if (!status.isSet && (item.qop > item.qty) && item.total_rec < item.total_need_filled){
								status.value = "Partial";
								status.isSet = true;
							}

							if (!status.isSet && (item.qop < item.total_rec || item.total_rec > item.total_need_filled)){
								status.value = "Over Received";
								status.isSet = true;
							}

							if(item.total_rec == item.total_need_filled) {
								status.value = "OK";
								status.isSet = true;
							}

						} else {
							if(item.total_need_filled < item.total_rec){
								status.value = 'Over Received';
							}else{
								status.value = 'OK';
							}
							
						}
					} else{
						if(item.qty != item.qor){
							if (item.qor == 0 || item.qor == null){
								status.value = "NO RGA";
								status.isSet = true;
							}
							if (!status.isSet && (item.qor > item.qty)){
								status.value = "Partial Return";
								status.isSet = true;
							}
							if (!status.isSet && (item.qor < item.qty)){
								status.value = "Over Return";
								status.isSet = true;
							}
						}else{
							status.value = 'OK';
						}
					}

					switch(status.value){
						case 'NO PO':
							tableBody += `<tr style="background-color: ${red};">`;
							legend.rec['NO PO'] = red;
							break;
						case 'NO RGA':
							tableBody += `<tr style="background-color: ${pink};">`;
							legend.send['NO RGA'] = pink;
							break;
						case 'Partial Return':
							tableBody += `<tr style="background-color:  ${yellow};">`;
							legend.shared['Partial'] = yellow;
							break;
						case 'Over Return':
							tableBody += `<tr style="background-color: ${blue};">`;
							legend.send['Over Return'] = blue;
							break;
						case 'Partial':
							tableBody += `<tr style="background-color: ${yellow};">`;
							legend.shared['Partial'] = yellow;
							break;
						case 'Over Received':
							tableBody += `<tr style="background-color: ${orange};">`;
							legend.rec['Over Received'] = orange;
							break;
						default:
							if(status.value == 'OK'){
								if(item.in_out == 0){
									tableBody += `<tr style="background-color: ${green};">`;
									legend.rec['OK (REC)'] = green;
								} else{
									tableBody += `<tr style="background-color: ${purple};">`;
									legend.send['OK (SEND)'] = purple;
								}
							}
						break;
					}


					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + index + "</td>";

					if(item.stockid === 'MST'){
						tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + '<a href="https://clevehilltire.com/v8/#/inventory/view/' + item.stockid + '" style="color: #3498db; text-decoration: none;">'+item.stockid+"</a>"+" (#" + item.ponumber+ " )</td>";
					} else {
						tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + '<a href="https://clevehilltire.com/v8/#/inventory/view/' + item.stockid + '" style="color: #3498db; text-decoration: none;">'+item.stockid+"</a></td>";
					}


					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + item.vendor.toString() + "</td>";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + item.bin.toString() + "</td>";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd; font-weight: bold;">' + item.qty.toString() + "</td>";

					let min = item.minmax.minimum !== undefined && item.minmax.minimum !== null ? item.minmax.minimum.toString() : "-";
					let max = item.minmax.maximum !== undefined && item.minmax.maximum !== null ? item.minmax.maximum.toString() : "-";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + min + "</td>";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + max + "</td>";

					let onhand = item.qoh !== null ? item.qoh.toString() : "0";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + onhand + "</td>";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + item.qop.toString() + "</td>";


					
					let remaining = parseInt(item.qop) != 0 ? (item.qop - item.total_rec).toString() : "-";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + remaining + "</td>";
					
					

					let rma = item.qor == null ? "0" : item.qor.toString();
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + rma + "</td>";

					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd;">' + item.qos.toString() + "</td>";
					tableBody += '<td style="text-align: center; padding: 8px; border: 1px solid #ddd; font-weight: bold;">' + status.value.toString() + "</td></tr>";

					index++;

				});
			}

			(bodyIndex == 0) ? validScansBody = tableBody: invalidScansBody = tableBody;
			tableBody = '';
			bodyIndex++;
			});



		let combinedBody =  '<tbody>' + validScansBody + invalidScansBody + '</tbody></table>';
		let validTable = (validScansBody.length > 0 ) ? tableHead + "<tbody>" + validScansBody + "</tbody></table>" : "";
		let invalidTable = (invalidScansBody.length > 0 ) ? tableHead + "<tbody>" + invalidScansBody + "</tbody></table>" : "";
		let combinedTable = tableHead + combinedBody;

		

		let overallInformation = {
			"Scan Amount" : this.totalScannedRec(),
			"Total Received" : this.totalScannedRec(),
			"On PO" : this.totalForPo(),
			"Requires PO" : this.totalReqPo(),
			"Total Sent" : this.totalScannedSend(),
			"On RGA" : this.totalForRga(),
			"Requires RGA" : this.totalReqRga(),
			"First Scan Time" : this.getFirstScanTime() !== '-' ? new Date(this.getFirstScanTime()).toLocaleString() : '-',
			"Last Scan Time" : this.getLastScanTime() !== '-' ? new Date(this.getLastScanTime()).toLocaleString() : '-',
			"Duration (seconds)" : this.getDurationSeconds(),
			"% Over Scan" : this.getOverScanPercentage() + "%",
			"% Good" : this.getGoodPercentage() + "%"
		}

		let info_html = '<table style="border-collapse: collapse; width: 100%; margin: 20px 0; font-family: Arial, sans-serif;">';
		info_html += '<thead><tr style="background-color: #333; color: white;"><th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Metric</th><th style="padding: 10px; text-align: right; border: 1px solid #ddd;">Value</th></tr></thead>';
		info_html += '<tbody>';
		Object.entries(overallInformation).forEach(([key, value], index) => {
			let bgColor = index % 2 === 0 ? '#f9f9f9' : '#ffffff';
			info_html += `<tr style="background-color: ${bgColor};"><td style="padding: 8px; border: 1px solid #ddd; font-weight: bold;">${key}</td><td style="padding: 8px; border: 1px solid #ddd; text-align: right;">${value}</td></tr>`;
		});
		info_html += '</tbody></table>';



		let legend_html = '<table style="border-collapse: collapse; width: 100%; margin: 20px 0; font-family: Arial, sans-serif;">';
		legend_html += '<thead><tr style="background-color: #333; color: white;"><th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Status</th><th style="padding: 10px; text-align: left; border: 1px solid #ddd;">Type</th></tr></thead>';
		legend_html += '<tbody>';
		
		Object.entries(legend.rec).forEach(([Key, Value], index) => {
			let bgColor = index % 2 === 0 ? '#f9f9f9' : '#ffffff';
			legend_html += `<tr style="background-color: ${bgColor};"><td style="padding: 8px; border: 1px solid #ddd; background-color: ${Value}; width: 30px;"></td><td style="padding: 8px; border: 1px solid #ddd;">${Key} (Receiving)</td></tr>`;
		});

		Object.entries(legend.send).forEach(([Key, Value], index) => {
			let bgColor = (Object.keys(legend.rec).length + index) % 2 === 0 ? '#f9f9f9' : '#ffffff';
			legend_html += `<tr style="background-color: ${bgColor};"><td style="padding: 8px; border: 1px solid #ddd; background-color: ${Value}; width: 30px;"></td><td style="padding: 8px; border: 1px solid #ddd;">${Key} (Sending)</td></tr>`;
		});

		Object.entries(legend.shared).forEach(([Key, Value], index) => {
			let bgColor = (Object.keys(legend.rec).length + Object.keys(legend.send).length + index) % 2 === 0 ? '#f9f9f9' : '#ffffff';
			legend_html += `<tr style="background-color: ${bgColor};"><td style="padding: 8px; border: 1px solid #ddd; background-color: ${Value}; width: 30px;"></td><td style="padding: 8px; border: 1px solid #ddd;">${Key}</td></tr>`;
		});

		legend_html += '</tbody></table>';


		let session_stats = {
			userid: this.user?.user?.userid || '',
			loccode: this.location || '',
			time_start: this.getFirstScanTime(),
			time_stop: this.getLastScanTime(),
			duration_seconds: this.getDurationSeconds(),
			over_scan_percent: this.getOverScanPercentage(),
			good_percent: this.getGoodPercentage(),
			total_items_scanned: this.recitems ? this.recitems.length : 0,
			valid_scans_count: this.validScans.length,
			invalid_scans_count: this.invalidScans.length
		};

		console.log('Sending session_stats:', session_stats);

		let data = {
			invalid_html: 	Buffer.from(invalidTable.toString(),'utf8').toString('base64'),
			valid_html: 	Buffer.from(validTable.toString(),'utf8').toString('base64'),
			combined_html: 	Buffer.from(combinedTable.toString(),'utf8').toString('base64'),
			info_html: 		Buffer.from(info_html.toString(),'utf8').toString('base64'),
			legend_html: 	Buffer.from(legend_html.toString(),'utf8').toString('base64'),
			session_stats: session_stats
		};

		console.log('Sending mailDiscrepancy with data keys:', Object.keys(data));

		this.purchasingService.mailDiscrepancy(data).subscribe(results => {
			if(results['mail_sent'] == false){
				this.mail_loop(data);
			}
		});
	}

	mail_loop(data){
		this.purchasingService.mailDiscrepancy(data).subscribe(results => {
			if(results['mail_sent'] == false){
				this.mail_loop(data);
			}
		});
	}

	back(): void {
		this.location.back()
	}

}
